import * as React from 'react';

import { cn } from '../../../../utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	type?: string;
	className?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				className={cn(
					'flex-1 min-w-0 block w-full h-11 p-3 text-base rounded border-primaryBorder placeholder:text-base placeholder:text-disabledText',
					className
				)}
				ref={ref}
				type={type}
				{...props}
			/>
		);
	}
);
